'use strict';

import SignupController from './signup.controller';

export default angular.module('leafApp.signup', [])
  .controller('SignupController', SignupController)
  .name;
